export default {
  install (Vue, options) {
    Vue.mixin({
      computed: {
        isMobile () { return this.$vuetify.breakpoint.xsOnly; }
      }
    });
  }
};
